class NewsLetterWindow extends HTMLElement {
  constructor() {
    super();
    this.customer = this.getAttribute('data-customer-logged-in');

    this.delayBeforeDisplay = +this.getAttribute('data-delay-before-display') || 0;
    this.closeBtn = this.querySelectorAll('.js-newsletter-window__close');
    this.windowHolder = this.closest('.newsletter-window-holder');
    this.triggerOpenModalWindow = document.querySelectorAll('.js-trigger-newsletter-modal');
    this.buttonCloseModalWindow = this.querySelector('.js-newsletter-window__button-close');
    this.KEY_DATA_VALUE = 'dataNewsletterWindow';
    this.focusableSelector = 'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    this.restoreFocusElement = null;
    this.openedByTrigger = false;
    this.inertElements = [];
    this.onKeyDown = this.onKeyDown.bind(this);

    const baseData = {
      'isFirstShowWindow': true,
      'isSuccess': false,
      'isFirstShowSuccessWindow': false,
      'abVariant': null
    };


    if (this.getDataWindow() === null) {
      this.setDataWindow(baseData);
    }




    this.initABTesting();


    this.render();
  }

  initABTesting() {
    let variant = this.getValueDataWindow('abVariant');

    if (!variant) {
      variant = Math.random() > 0.5 ? 'A' : 'B';
      this.setValueDataWindow('abVariant', variant);
    }

    this.classList.add(`is-variant-${variant.toLowerCase()}`);

    // Знаходимо поле з тегами
    const tagsInput = this.querySelector('.js-newsletter-tags');
    if (tagsInput) {
      // Додаємо варіант до існуючих тегів (напр. "newsletter, AB_Variant_A")
      tagsInput.value = `newsletter, AB_Variant_${variant}`;
    }

    if (window.gtag) {
      gtag('event', 'ab_test_view', { 'variant': variant });
    }

    console.log('A/B testing switched to tags. Variant:', variant);
  }

  showButtonTrigger() {
    // Показуємо кнопку (прибираємо клас hidden)
    this.triggerOpenModalWindow.forEach(item => item.classList.remove('hidden'));
  }

  hideButtonTrigger() {
    // Ховаємо кнопку
    this.triggerOpenModalWindow.forEach(item => item.classList.add('hidden'));
  }

  getDataWindow() {
    return JSON.parse(localStorage.getItem(this.KEY_DATA_VALUE));
  }

  setDataWindow(data) {
    return localStorage.setItem(this.KEY_DATA_VALUE, JSON.stringify(data));
  }

  getValueDataWindow(key) {
    const data = JSON.parse(localStorage.getItem(this.KEY_DATA_VALUE));
    return data ? data[key] : null;
  }

  setValueDataWindow(key, value) {
    const data = this.getDataWindow();
    if (data) {
      data[key] = value;
      this.setDataWindow(data);
    }
  }

  getFocusableElements() {
    return Array.from(this.querySelectorAll(this.focusableSelector)).filter(element => {
      const style = window.getComputedStyle(element);

      return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
    });
  }

  setBackgroundInert() {
    if (!this.windowHolder || !document.body) return;

    const inertElements = new Set();
    let activeElement = this.windowHolder;

    while (activeElement?.parentElement && activeElement.parentElement !== document.body) {
      Array.from(activeElement.parentElement.children).forEach(element => {
        if (element !== activeElement) inertElements.add(element);
      });

      activeElement = activeElement.parentElement;
    }

    Array.from(document.body.children).forEach(element => {
      if (element !== activeElement) inertElements.add(element);
    });

    this.inertElements = Array.from(inertElements).map(element => ({
      element,
      wasInert: element.inert
    }));

    this.inertElements.forEach(({ element }) => {
      element.inert = true;
    });
  }

  releaseBackgroundInert() {
    this.inertElements.forEach(({ element, wasInert }) => {
      element.inert = wasInert;
    });

    this.inertElements = [];
  }

  focusInitialElement() {
    if (!this.windowHolder?.classList.contains('show')) return;

    const focusableElements = this.getFocusableElements();
    const emailInput = this.querySelector('input[type="email"]:not([disabled])');
    const focusTarget = focusableElements.includes(emailInput) ? emailInput : focusableElements[0] || this;

    focusTarget.focus({ preventScroll: true });
  }

  onKeyDown(event) {
    if (!this.windowHolder?.classList.contains('show')) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      this.closeWindow();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusableElements = this.getFocusableElements();

    if (!focusableElements.length) {
      event.preventDefault();
      this.focus({ preventScroll: true });
      return;
    }

    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && (document.activeElement === firstFocusableElement || document.activeElement === this)) {
      event.preventDefault();
      lastFocusableElement.focus();
    }

    if (!event.shiftKey && document.activeElement === lastFocusableElement) {
      event.preventDefault();
      firstFocusableElement.focus();
    }
  }

  closeWindow() {
    this.windowHolder.classList.remove('show');
    this.windowHolder.classList.add('close');
    this.showButtonTrigger();
    document.removeEventListener('keydown', this.onKeyDown);
    this.releaseBackgroundInert();
    this.setValueDataWindow('isFirstShowSuccessWindow', false);

    if (this.openedByTrigger && this.restoreFocusElement?.isConnected) {
      this.restoreFocusElement.focus({ preventScroll: true });
    } else if (this.contains(document.activeElement)) {
      document.activeElement.blur();
    }

    this.restoreFocusElement = null;
    this.openedByTrigger = false;
  }

  showWindow(triggerElement = null) {
    if (this.windowHolder.classList.contains('show')) return;

    this.restoreFocusElement = triggerElement;
    this.openedByTrigger = Boolean(triggerElement);
    this.windowHolder.classList.remove('close');
    this.windowHolder.classList.add('show');
    this.hideButtonTrigger();
    this.setBackgroundInert();
    document.addEventListener('keydown', this.onKeyDown);

    requestAnimationFrame(() => this.focusInitialElement());

    this.setValueDataWindow('isFirstShowWindow', false);
  }

  attachEvents() {
    this.closeBtn.forEach(item => item.addEventListener('click', () => this.closeWindow()));

    this.triggerOpenModalWindow.forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        this.showWindow(e.currentTarget);
      })
    });

    document.addEventListener('click', (e) => {
      const target = e.target;

      if (!target.closest('.newsletter-window') && target.closest('.newsletter-window-holder.show')) {
        this.closeWindow();
      }
    });
  }

  showSuccessMessage() {
    const newsletterFormContainer = this.querySelector('.js-newsletter-form__field-wrapper');
    const successMessageContainer = this.querySelector('.js-newsletter-form__successfull-message');

    if (this.getValueDataWindow('isSuccess') === true) {
      const variant = this.getValueDataWindow('abVariant');
      if (typeof gtag === 'function') {
        gtag('event', 'newsletter_signup', {
          'event_category': 'engagement',
          'event_label': 'AB_Test_Popup',
          'ab_variant': variant
        });
      }
      newsletterFormContainer?.classList.add('d-none');
      successMessageContainer?.classList.remove('d-none');
      this.buttonCloseModalWindow?.classList.remove('d-none');
    }
  }

  render() {

    this.attachEvents();
    this.showSuccessMessage();


    if (this.customer === 'true') {
      this.showButtonTrigger();
      return;
    }

    const delay = this.delayBeforeDisplay * 1000;
    if (this.getValueDataWindow('isFirstShowSuccessWindow') && this.getValueDataWindow('isSuccess')) {
      this.showWindow();
      return;
    }


    if (this.getValueDataWindow('isFirstShowWindow')) {

      this.hideButtonTrigger();

      setTimeout(() => {

        if (!this.windowHolder.classList.contains('show')) {
          this.showWindow();
        }
      }, delay);
    }

    else {
      this.showButtonTrigger();
    }
  }
}

customElements.define('newsletter-window', NewsLetterWindow);
